<template>
  <div style="height: 80px; width: 130px">
    <div style="position: absolute">
      <div class="price-tag">₹ {{ object.price }}</div>
    </div>
    <v-img
      :src="object.thumbnail.file"
      alt="playlist"
      height="100%"
      width="100%"
      style="border-radius: 5px"
    />
  </div>
</template>
<script>
export default {
  name: "Video",
  props: ["object"],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style scoped>
.price-tag {
  width: 60px;
  left: 70px;
  bottom: 00px;
  position: relative;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: #b1d5ff;
  color: #093060;
  font-weight: bold;
}
</style>
